export enum AuthenticationMethods {
    Password = 0,
    OpenId = 1
}
